import React from 'react';
import { Helmet } from 'react-helmet';
import { consultantInfo } from '../mock';

const SEO = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Person",
        "@id": "https://akshaysonalkar.com/#person",
        "name": "Akshay Sonalkar",
        "image": "https://akshaysonalkar.com/akshay-photo.jpg",
        "jobTitle": "Software Engineer",
        "description": "Software engineer with 10+ years of experience. Passionate about open source, software engineering education, and mentoring developers.",
        "url": "https://akshaysonalkar.com",
        "email": "sonalkarakshay.solapur@gmail.com",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "addressCountry": "IN"
        },
        "sameAs": [
          `https://${consultantInfo.linkedin}`,
          "https://github.com/akshay-sonalkar"
        ]
      },
      {
        "@type": "WebSite",
        "@id": "https://akshaysonalkar.com/#website",
        "url": "https://akshaysonalkar.com",
        "name": "Akshay Sonalkar - Software Engineer & Open Source Enthusiast",
        "description": "Personal portfolio of Akshay Sonalkar, software engineer. Open source enthusiast and engineering mentor.",
        "publisher": {
          "@id": "https://akshaysonalkar.com/#person"
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://akshaysonalkar.com/"
          }
        ]
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
